import * as yup from 'yup';
import { ERROR_MESSAGES } from 'utils/form';

const JOINED_LOYALTY_PROGRAM_AFTER = 'joinedLoyaltyProgramAfter';
const JOINED_LOYALTY_PROGRAM_BEFORE = 'joinedLoyaltyProgramBefore';

const BODY_SCHEMA = yup.object({
  [JOINED_LOYALTY_PROGRAM_AFTER]: yup.date().nullable(),
  [JOINED_LOYALTY_PROGRAM_BEFORE]: yup
    .date()
    .nullable()
    .when([JOINED_LOYALTY_PROGRAM_AFTER], {
      is: (joinedLoyaltyProgramAfter: Date) => !!joinedLoyaltyProgramAfter,
      then: (schema) =>
        schema.min(
          yup.ref(JOINED_LOYALTY_PROGRAM_AFTER),
          ERROR_MESSAGES.invalidDateRange,
        ),
    }),
});

export {
  JOINED_LOYALTY_PROGRAM_AFTER,
  JOINED_LOYALTY_PROGRAM_BEFORE,
  BODY_SCHEMA,
};
